import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelectedTeamIdAtom } from '../../atoms/teams/useSelectedTeamIdAtom';

const TeamList = ({ teams }) => {
    
    const navigate = useNavigate();
    const [selectedTeamId, setSelectedTeamId] = useSelectedTeamIdAtom();

    const handleTeamClick = (id) => {
      setSelectedTeamId(id);
      navigate('/EditTeam');
    };

    return (
        <>
        {teams.map((team, key) => (
            <div key={key} className={`team-item ${selectedTeamId === team.value ? 'active' : ''}`}>
                <div onClick={() => handleTeamClick(team.value)}>
                    <div className="team-icon">{team.label.charAt(0)}</div>
                    <span className={"team-name-label"}>{team.label}</span>
                </div>
            </div>
        ))}
        </>
    );
}

export default TeamList;